<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'serviceobjecttypeints_new'" (ttClick)="goToFunc('serviceobjecttypeint')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListIntervals"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <div ng-if="vm.model.setting.page_heading > ''">
            <tt-header tt-model="vm.model.setting.page_heading"></tt-header>
            <div class="k-hr col-xs-12 sp-0"></div>
        </div>
        <tt-button class="col-xs-12 sp-0" tt-text="serviceobjecttypeints_new" tt-click="vm.goToFunc('serviceobjecttypeint')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>
    <tt-list class="col-xs-12 col-md-6 sp-0" list-items="vm.model.itemsListIntervals" badge="" ltype="" design-var="s12t0"></tt-list>
</tt-page>-->
